

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) readonly slideCount: number;
  @Prop({ required: true }) readonly activeSlide: number;
  @Prop({ required: false }) readonly colour: string;

  goTo(slide: number) {
    this.$emit('go-to', slide);
  }
}
